<template>
    <div class="app-container">
        <PtHeader :service="headerService" >
            <template #logo>
                <LogoPatSnap />
            </template>
            <template #timer>
                <PtHeaderWidgetCaseTime :service="caseTimeService" />
            </template>
        </PtHeader>
        <div class="app-body">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import headerMixin from './mixins/headerMixin';
export default {
    mixins: [
        headerMixin
    ],
    data() {
        return {
        };
    },
    methods: {
    }
};
</script>

<style lang="scss">
    /*
    * fix element 弹框左侧滚动条占位样式引起页面抖动
    */
    .patsnap-design-popup__parent--hidden{
        padding-right: 0 !important;
    }
    svg.patsnap-biz-icon {
        font-size: 24px;
        margin-bottom: 0;
        color: #505F79;
    }
</style>
